import Vue from 'vue'
import VueRouter from 'vue-router'
import SchoolsManagement from '../views/pages/SchoolsManagement'
import UserSchool from '../views/pages/SchoolsManagement/tabs/index.vue'
import AdminLayout from "../views/AdminLayout.vue";
import Login from "../views/Login.vue";
import SystemNotification from "../views/pages/SystemNotification";
import UserManagement from "../views/pages/UserManagement";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '',
    name: 'layout',
    component: AdminLayout,
    children: [
      {
        path: '/',
        name: 'schools-management',
        component: SchoolsManagement,
      },
      {
        path: '/user/school/:id?',
        name: 'user-school',
        component: UserSchool,
      },
      {
        path: '/system-notification',
        name: 'system-notification',
        component: SystemNotification,
      },
      {
        path: '/user-management',
        name: 'user-management',
        component: UserManagement,
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
